export enum FeedbackRating {
    VERY_SAD = 4,
    SAD = 3,
    HAPPY = 2,
    VERY_HAPPY = 1
  }